import { Alert, Button, Collapse } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  cachedAt: Date | null;
  revalidating: boolean;
  onRefresh: () => void;
  onDismiss: () => void;
};

const formatCachedTime = (date: Date | null, locale?: string) => {
  if (!date) return '';
  return date.toLocaleString(locale, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const DashboardStaleAlert = ({ open, cachedAt, revalidating, onRefresh, onDismiss }: Props) => {
  const { t, i18n } = useTranslation();

  return (
    <Collapse in={open}>
      <Alert
        severity="info"
        sx={{ mb: 2, borderRadius: 2, alignItems: 'center' }}
        action={
          <>
            <Button color="inherit" size="small" onClick={onDismiss} sx={{ mr: 0.5 }}>
              {t('common:dashboard.cache.dismiss')}
            </Button>
            <Button
              color="inherit"
              size="small"
              variant="outlined"
              onClick={onRefresh}
              disabled={revalidating}
            >
              {t('common:dashboard.cache.refresh')}
            </Button>
          </>
        }
      >
        {t('common:dashboard.cache.staleMessage', {
          time: formatCachedTime(cachedAt, i18n.language),
        })}
      </Alert>
    </Collapse>
  );
};

export default DashboardStaleAlert;